import { stepPropertyDamageExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const collisionDamageExpenses = mapToCollisionDamageExpenses(data);
  return [...collisionDamageExpenses];
}

function mapToCollisionDamageExpenses(data) {
  if (data.areYouClaimingForPropertyDamage !== 'true' || data.expenseDescriptionOfItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.propertyDamage.claimCode;
  const expenses = [];

  data.expenseDescriptionOfItems.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapCollisionDamageExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.amountPaidLoss || !item.currentAmountPaidLoss) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: item.dateOfLoss,
    clientCost: item.amountPaidLoss,
    currency: item.currentAmountPaidLoss,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

function mapReimbursement(item, formData, claimCode) {
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPropertyDamageDataMapper.js